var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 3.6416H7C4 3.6416 2 5.1416 2 8.6416V15.6416C2 19.1416 4 20.6416 7 20.6416H17C20 20.6416 22 19.1416 22 15.6416V8.6416C22 5.1416 20 3.6416 17 3.6416ZM17.47 9.7316L14.34 12.2316C13.68 12.7616 12.84 13.0216 12 13.0216C11.16 13.0216 10.31 12.7616 9.66 12.2316L6.53 9.7316C6.21 9.4716 6.16 8.9916 6.41 8.6716C6.67 8.3516 7.14 8.2916 7.46 8.5516L10.59 11.0516C11.35 11.6616 12.64 11.6616 13.4 11.0516L16.53 8.5516C16.85 8.2916 17.33 8.3416 17.58 8.6716C17.84 8.9916 17.79 9.4716 17.47 9.7316Z",
    fill: "#033A3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail_icon.32a1af2a3fd9b6c17522b7c34050a054.svg";
export { ForwardRef as ReactComponent };